
import { ArrowRight, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import FoundersBanner from "./FoundersBanner";
import useMetaTracking from "@/hooks/use-meta-tracking";
import useAnalytics from "@/hooks/use-analytics";

const HeroSection = () => {
  const { trackViewContent } = useMetaTracking();
  const { trackButtonClick } = useAnalytics();
  
  // Para navegação suave entre seções da mesma página
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
    
    // Troca de trackLead para trackButtonClick para ter uma métrica de engajamento 
    // sem contabilizar como conversão de lead
    if (id === "planos") {
      trackButtonClick("cadastro_clinica", "hero_section");
      
      // Rastreia a visualização da seção como conteúdo, não como lead
      trackViewContent({
        content_name: "planos_section",
        content_category: "section_view"
      });
    }
  };

  return (
    <section className="bg-gradient-to-b from-drcash-maastricht-blue to-drcash-sapphire-blue min-h-screen flex items-center pt-24 pb-16 relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-drcash-caribbean-green/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-drcash-tiffany-blue/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-12">
          <FoundersBanner />
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            A Dr.Cash cuida da{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue">saúde financeira</span>
            <br /> da sua clínica
          </h1>
          <p className="text-xl text-drcash-cadet-gray max-w-3xl mx-auto mb-10">
            Criamos um conjunto de soluções financeiras para manter seu fluxo de caixa sempre saudável
          </p>
        </div>

        {/* Botões refinados e arredondados, fora do fundo branco */}
        <div className="flex flex-col md:flex-row gap-4 justify-center items-center mt-4">
          <Button
            size="sm"
            variant="default"
            className="rounded-full px-4 py-2 text-sm font-semibold shadow-lg transition-transform duration-200 hover:scale-105 group"
            onClick={() => scrollToSection("planos")}
          >
            <Home className="mr-2 h-4 w-4 group-hover:animate-float" />
            Cadastre sua clínica
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button
            size="sm"
            variant="secondary"
            className="rounded-full px-4 py-2 text-sm font-semibold shadow-lg transition-transform duration-200 hover:scale-105 group"
            onClick={() => scrollToSection("servicos")}
          >
            <ArrowRight className="mr-2 h-4 w-4 group-hover:animate-float" />
            Ver serviços
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
